import { useSelector } from "react-redux";
import Modal from "components/Modal/Modal";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";
import { deleteCharge, requestDeletingCharge, selectState } from "../charges.slice";
import { FormatDateShort } from "utils/dateUtils";

interface IProps {
  onDeleted?: () => void;
}

const DeleteChargeModal = ({ onDeleted }: IProps) => {
  const { chargeToDelete } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(requestDeletingCharge(undefined));
  };

  const doDelete = async () => {
    if (chargeToDelete === undefined) {
      return;
    }
    try {
      await dispatch(deleteCharge({ resourceId: chargeToDelete.resource.resourceId, chargeId: chargeToDelete.chargeId })).unwrap();
      toast.success("Zaduženje je uspešno obrisano.");
      close();
      onDeleted?.();
    } catch (err) {
      toast.error("Neočekivana greška");
    }
  };

  return (
    <Modal
      onClose={close}
      onClick={doDelete}
      isOpen={chargeToDelete !== undefined}
      title="Brisanje zaduženja"
    >
      <p className="info-msg">
        {chargeToDelete && `Da li ste sigurni da želite da obrišete zaduženje (${chargeToDelete.employee.name}, ${chargeToDelete.project.name}, ${FormatDateShort(chargeToDelete.dateCharge)})?`}
      </p>
    </Modal>
  );
};

export default DeleteChargeModal;
